import {Video} from "../../types/admin";
import {ADMIN_LANG} from "../../settings";
import {Form, InputGroup} from "react-bootstrap";
import React from "react";
import MediaPreview from "./MediaPreview";

type Props = {
    defaultVideo: Video | null
    setVideo: (video: File | null) => void
    label?: string
    help_text?: string
    accept?: string
}

const VideoField = ({
                        defaultVideo,
                        setVideo,
                        label = ADMIN_LANG.video,
                        help_text = ADMIN_LANG.video_help,
                        accept = 'video/mp4'
                    }: Props) => {

    const handleVideoAdd = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            setVideo(e.target.files[0]);
        }
    }

    let elem;

    if (defaultVideo) {
        elem = (
            <Form.Group className='pb-3'>
                <Form.Label>{label}</Form.Label>
                <MediaPreview kind='video' src={defaultVideo.url} onAction={() => setVideo(null)}/>
            </Form.Group>
        );
    } else {
        elem = (
            <Form.Group className='pb-3' controlId={label}>
                <Form.Label>{label}</Form.Label>
                <InputGroup>
                    <Form.Control type='file' onChange={handleVideoAdd}
                                  accept={accept}/>
                </InputGroup>
                <Form.Text className='help-text'
                           dangerouslySetInnerHTML={{__html: help_text}}></Form.Text>
            </Form.Group>
        );
    }

    return (
        <>
            {elem}
        </>
    )
}


export default VideoField;